import Table from "react-bootstrap/Table";
import "../Styles/Admin.css";
import ActiveIcon from "../Assets/Icons/activeIcon.svg";
import InActiveIcon from "../Assets/Icons/inActiveIcon.svg";
import { Button } from "react-bootstrap";
import MerchantImg from "../Assets/Images/MerchantImg.png";
import BlockIcon from "../Assets/Icons/blockIcon.svg";

export default function SuperAdminTable() {
  return (
    <Table style={{ textAlign: "center" }} hovered variant="light">
      <thead>
        <tr>
          <th
            style={{
              backgroundColor: "#E0E0E0",
              borderRadius: "6px 0px 0px 0px",
            }}
          >
            s.no
          </th>
          <th
            style={{
              backgroundColor: "#E0E0E0",
            }}
          >
            Admin name
          </th>
          <th style={{ backgroundColor: "#E0E0E0" }}>Contact</th>
          <th style={{ backgroundColor: "#E0E0E0" }}>Status</th>
          <th style={{ backgroundColor: "#E0E0E0" }}>Date</th>
          <th
            style={{
              backgroundColor: "#E0E0E0",
              borderRadius: "0px 6px 0px 0px",
            }}
          >
            ACTION
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.50rem",
              }}
            >
              <img
                style={{ width: "2rem", height: "2rem" }}
                src={MerchantImg}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "start",
                  flexDirection: "column",
                }}
              >
                <h4
                  style={{
                    fontSize: "0.70rem",
                    color: "#303030",
                    margin: "0px",
                  }}
                >
                  Naseem Muneer
                </h4>
                <p style={{ fontSize: "0.70rem", color: "#008BD9" }}>
                  Pakistan
                </p>
              </div>
            </div>
          </td>
          <td>+923160598938</td>
          <td>
            {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
              }}
            >
              <img style={{ marginTop: "1px" }} src={ActiveIcon} /> Active
            </div>
          </td>
          <td>N 121552</td>
          <td>
            <Button style={{ height: "1.625rem", fontSize: "0.70rem" }}>
              View
            </Button>
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.50rem",
              }}
            >
              <img
                style={{ width: "2rem", height: "2rem" }}
                src={MerchantImg}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "start",
                  flexDirection: "column",
                }}
              >
                <h4
                  style={{
                    fontSize: "0.70rem",
                    color: "#303030",
                    margin: "0px",
                  }}
                >
                  Naseem Muneer
                </h4>
                <p style={{ fontSize: "0.70rem", color: "#008BD9" }}>
                  Pakistan
                </p>
              </div>
            </div>
          </td>
          <td>+923160598938</td>
          <td>
            {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
              }}
            >
              <img style={{ marginTop: "1px" }} src={BlockIcon} /> Blocked
            </div>
          </td>
          <td>N 121552</td>
          <td>
            <Button style={{ height: "1.625rem", fontSize: "0.70rem" }}>
              View
            </Button>
          </td>
        </tr>
        <tr>
          <td>3</td>
          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.50rem",
              }}
            >
              <img
                style={{ width: "2rem", height: "2rem" }}
                src={MerchantImg}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "start",
                  flexDirection: "column",
                }}
              >
                <h4
                  style={{
                    fontSize: "0.70rem",
                    color: "#303030",
                    margin: "0px",
                  }}
                >
                  Naseem Muneer
                </h4>
                <p style={{ fontSize: "0.70rem", color: "#008BD9" }}>
                  Pakistan
                </p>
              </div>
            </div>
          </td>
          <td>+923160598938</td>
          <td>
            {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
              }}
            >
              <img style={{ marginTop: "1px" }} src={ActiveIcon} /> Active
            </div>
          </td>
          <td>N 121552</td>
          <td>
            <Button style={{ height: "1.625rem", fontSize: "0.70rem" }}>
              View
            </Button>
          </td>
        </tr>
        <tr>
          <td>4</td>
          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.50rem",
              }}
            >
              <img
                style={{ width: "2rem", height: "2rem" }}
                src={MerchantImg}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "start",
                  flexDirection: "column",
                }}
              >
                <h4
                  style={{
                    fontSize: "0.70rem",
                    color: "#303030",
                    margin: "0px",
                  }}
                >
                  Naseem Muneer
                </h4>
                <p style={{ fontSize: "0.70rem", color: "#008BD9" }}>
                  Pakistan
                </p>
              </div>
            </div>
          </td>
          <td>+923160598938</td>
          <td>
            {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
              }}
            >
              <img style={{ marginTop: "1px" }} src={BlockIcon} /> Blocked
            </div>
          </td>
          <td>N 121552</td>
          <td>
            <Button style={{ height: "1.625rem", fontSize: "0.70rem" }}>
              View
            </Button>
          </td>
        </tr>
      </tbody>
    </Table>
  );
}
